export default {
  methods: {
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;

      if (el) {
        if (window.innerWidth > 992) {
          this.$parent.$refs.content.scrollTop = el.offsetTop - 112;
        } else {
          this.$parent.$refs.content.scrollTop = el.offsetTop - 80;
        }
      }
    },
  },
};
